module.exports = __webpack_public_path__ + "img/friends-banner.45a9e761.png";